import { useEffect, useState } from "react";
import { usePortalState } from "~/utils/states";

export const usePortalHydration = () => {
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		// Check if already hydrated
		if (usePortalState.persist.hasHydrated()) {
			setHydrated(true);
			return;
		}

		// Listen for hydration completion
		const unsubscribe = usePortalState.persist.onFinishHydration(() => {
			setHydrated(true);
		});

		// Fallback: force hydration after timeout if not completed
		const fallbackTimer = setTimeout(() => {
			setHydrated(true);
		}, 1000);

		return () => {
			unsubscribe();
			clearTimeout(fallbackTimer);
		};
	}, []);

	return hydrated;
};
